module.exports = __webpack_public_path__ + "img/voucher-background.69cd8a0.png";